import React from 'react';
import { I18n } from '@aws-amplify/core';
import { GenerateButton } from '../styles';
import { useResponsive } from '../SurveyResponse/hooks/useResponsive';

interface GeneratePinButtonProps {
	onClick: () => Promise<void>;
	isDisabled: boolean;
	isLoading: boolean;
}

export function GeneratePinButton({ onClick, isLoading, isDisabled }: GeneratePinButtonProps) {
	const { isMobile } = useResponsive();

	return (
		<GenerateButton
			htmlType="button"
			onClick={onClick}
			loading={isLoading}
			disabled={isDisabled}
			style={{ width: isMobile ? '100%' : ' 100px' }}
		>
			{I18n.get('Generate PIN')}
		</GenerateButton>
	);
}
